<template>
    <div class="flex flex-wrap" :class="{'w-full max-w-full': !compact}">

        <div v-for="url in images">
            <a v-if="isImage(url)" :href="url" target="_blank" :data-fancybox="'comment-' + id + '-' + Number(compact)"
               class="block relative overflow-hidden rounded"
            >
                <img v-if="images.length === 1"
                     :src="url"
                     :style="{'max-height: 400px': !compact}"
                     :class="{'w-10 h-10 object-cover object-center': compact, ' w-full max-w-sm': !compact}"
                     class="rounded relative"
                     loading="lazy"
                     @load="reportLoaded"
                >
                <img v-else :class="{'w-10 h-10 object-cover object-center': compact, 'h-32 w-auto' : !compact}"
                     :src="url"
                     loading="lazy"
                     class="m-1 rounded"
                     @load="reportLoaded"
                >
            </a>
            <div v-else-if="isVideo(url)">
                <div v-if="compact" class="w-10 h-10 rounded m-1 bg-gray-500/50 flex items-center justify-center bg-cover bg-center"
                    :style="{backgroundUrl: 'url(' + videoCover(url) + ')'}"
                >
                    <svg-icon icon="play-circle" class="text-white w-4 h-4"></svg-icon>
                </div>
                <native-video
                    v-else
                    :url="url"
                    @load="reportLoaded"
                    :gif="isVideoFromGif(url)"
                    :poster="videoCover(url)"
                ></native-video>
            </div>
        </div>
    </div>
</template>
<script>
import Urls from "../../js/modules/Urls";
import NativeVideo from "../partials/NativeVideo.vue";
import SvgIcon from "../partials/SvgIcon.vue";

export default {
    components: {SvgIcon, NativeVideo},
    props: ['images', 'id', 'compact'],
    methods: {
        isImage(url) {
            return Urls.isImage(url)
        },
        isVideo(url) {
            return Urls.isVideo(url);
        },
        isVideoFromGif(url) {
            return Urls.isVideoFromGif(url);
        },
        reportLoaded() {
            this.$emit('mediaLoaded');
        },
        videoCover(url){
            return url + '.webp';
        }
    },
}
</script>